import { apiClient } from "./apiClient";

export type FichaTransferenciaItem = {
  id?: number;
  produtoId: number;
  descricao: string;
  unidade: string;
  undMedidaId: number | null;
  quantidadePrevista: string | null;
  quantidadeSobraAnterior: string | null;
  quantidadeProduzida: string | null;
  quantidadeTransferencia: string;
  producaoFinalizada?: boolean;
  itemManual: boolean;
  ordem?: number;
};

export type ListaFornecedorItem = {
  id?: number;
  quantidade: string | null;
  unidade: string | null;
  descricao: string;
  ordem?: number;
};

export type ListaFornecedor = {
  id?: number;
  fornecedor: string;
  previsaoChegada: string | null;
  dataTransferencia: string | null;
  ordem?: number;
  itens: ListaFornecedorItem[];
};

export type FichaTransferenciaLoja = {
  id: number;
  nome: string;
  rotulo: string;
};

export type FichaTransferencia = {
  id: number;
  dataReferencia: string;
  previsaoEntregaDiaSemana: number;
  previsaoEntrega: string;
  diaProgramado: boolean;
  producaoAssinada: boolean;
  origem: FichaTransferenciaLoja;
  destino: FichaTransferenciaLoja;
  criadoPor: { id: number; nome: string };
  createdAt: string;
  updatedAt: string;
  unds: { id: number; nome: string }[];
  itens: FichaTransferenciaItem[];
  listas: ListaFornecedor[];
};

export type FichaTransferenciaListaItem = {
  id: number;
  dataReferencia: string;
  origem: string;
  destino: string;
  rotuloOrigem: string;
  rotuloDestino: string;
  previsaoEntregaDiaSemana: number;
  previsaoEntrega: string;
  quantidadeItens: number;
  quantidadeListas: number;
  criadoPor: { id: number; nome: string };
  createdAt: string;
  updatedAt: string;
};

export type FichaTransferenciaLista = {
  page: number;
  pageSize: number;
  total: number;
  itens: FichaTransferenciaListaItem[];
};

export type FichaTransferenciaSugestao = {
  fichaId: number | null;
  dataReferencia: string;
  diaProgramado: boolean;
  producaoAssinada: boolean;
  origem: FichaTransferenciaLoja;
  destino: FichaTransferenciaLoja;
  unds: { id: number; nome: string }[];
  itens: FichaTransferenciaItem[];
};

export type ProdutoFichaTransferencia = {
  id: number;
  descricao: string;
  unidade: string;
  undMedidaId: number | null;
  lojaId: number;
  lojaNome: string;
};

export type SalvarFichaTransferenciaPayload = {
  dataReferencia: string;
  previsaoEntregaDiaSemana: number;
  itens: {
    produtoId: number;
    quantidadeTransferencia: string;
    undMedidaId: number;
  }[];
  listas: Omit<ListaFornecedor, "id" | "ordem">[];
};

export const fichaTransferenciaService = {
  listar: (params?: { data?: string; page?: number; pageSize?: number }) => {
    const qs = new URLSearchParams();
    if (params?.data) qs.set("data", params.data);
    if (params?.page) qs.set("page", String(params.page));
    if (params?.pageSize) qs.set("pageSize", String(params.pageSize));
    const query = qs.toString();
    return apiClient.get<FichaTransferenciaLista>(
      `/controle-producao/fichas-transferencia${query ? `?${query}` : ""}`
    );
  },

  sugestao: (data: string) =>
    apiClient.get<FichaTransferenciaSugestao>(
      `/controle-producao/fichas-transferencia/sugestao?data=${data}`
    ),

  produtos: () =>
    apiClient.get<ProdutoFichaTransferencia[]>(
      "/controle-producao/fichas-transferencia/produtos"
    ),

  obter: (id: number) =>
    apiClient.get<FichaTransferencia>(
      `/controle-producao/fichas-transferencia/${id}`
    ),

  criar: (payload: SalvarFichaTransferenciaPayload) =>
    apiClient.post<FichaTransferencia>(
      "/controle-producao/fichas-transferencia",
      payload
    ),

  atualizar: (
    id: number,
    payload: Omit<SalvarFichaTransferenciaPayload, "dataReferencia">
  ) =>
    apiClient.put<FichaTransferencia>(
      `/controle-producao/fichas-transferencia/${id}`,
      payload
    ),

  atualizarProducao: (id: number) =>
    apiClient.post<FichaTransferencia>(
      `/controle-producao/fichas-transferencia/${id}/atualizar-producao`,
      {}
    ),

  excluir: (id: number) =>
    apiClient.delete(`/controle-producao/fichas-transferencia/${id}`),
};
